<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>After an encounter with a mystery man in 2022, the author, Katie Whitlock, was inspired to write <em>Eternal Fire</em>. After researching the Hadron Collider, she decided to write about her experiences. She really wants to buy a dog.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?49923816